 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"clinics-chunk":"clinics-chunk","medicine-order-details-chunk":"medicine-order-details-chunk","profiler":"profiler","recorder":"recorder"}[chunkId]||chunkId) + "." + {"chunk-00321893":"2ab298ad","chunk-10b0dbf3":"e979a7f9","chunk-0c242480":"dc11c384","chunk-7f442d4c":"64815287","chunk-a16746c4":"2bfc35b1","clinics-chunk":"7852af85","chunk-3f6c33c0":"9666da00","medicine-order-details-chunk":"efcb14f7","chunk-c8b00de8":"4a84ad83","chunk-0720a51f":"010ea5a7","chunk-0e4b33d4":"83b8a15f","chunk-78a29d3e":"b8309620","chunk-16ecd102":"d4d2382f","chunk-2d0cbb32":"54ab4ac5","chunk-2d0d5fb5":"4130fcd5","chunk-2d1b9b31":"cfb6eb59","chunk-2d2138fa":"59bb785c","chunk-376798f9":"4bcd30ec","chunk-40b9f627":"8a5ebdfb","chunk-4f860653":"acb0b3f0","chunk-335ee7dc":"6935c230","chunk-cd3633e8":"5fd875ee","chunk-59f1cd2c":"52a25a52","chunk-5b4da50e":"df46978f","chunk-16712518":"f38185dc","chunk-195141ac":"0d56ce68","chunk-3b5d4ab0":"a1c190b6","chunk-c1197b9c":"713e9494","chunk-67536686":"5ee4c4b5","chunk-7cc2f306":"05f82938","chunk-08bf1a74":"095b2e15","chunk-4dd8db56":"dd9f5c9e","chunk-1a5b90f4":"187b84d5","chunk-1aafcde6":"9ee5282b","chunk-296c9694":"e2bbd435","chunk-7f9ad5e0":"a22a064a","chunk-7ff17d2c":"8f1a8c1e","chunk-9b5ecd7e":"f77be1ee","chunk-cdef5632":"42d1fbb5","chunk-2d0a4d8d":"43d3921b","chunk-2d2383be":"4596765f","chunk-dd16c636":"d3dcd1a5","profiler":"172f53bf","recorder":"be77bf2f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00321893":1,"chunk-10b0dbf3":1,"chunk-0c242480":1,"chunk-a16746c4":1,"clinics-chunk":1,"medicine-order-details-chunk":1,"chunk-c8b00de8":1,"chunk-0720a51f":1,"chunk-0e4b33d4":1,"chunk-78a29d3e":1,"chunk-16ecd102":1,"chunk-2d1b9b31":1,"chunk-376798f9":1,"chunk-40b9f627":1,"chunk-4f860653":1,"chunk-335ee7dc":1,"chunk-cd3633e8":1,"chunk-59f1cd2c":1,"chunk-5b4da50e":1,"chunk-16712518":1,"chunk-195141ac":1,"chunk-3b5d4ab0":1,"chunk-c1197b9c":1,"chunk-67536686":1,"chunk-7cc2f306":1,"chunk-08bf1a74":1,"chunk-4dd8db56":1,"chunk-1a5b90f4":1,"chunk-1aafcde6":1,"chunk-296c9694":1,"chunk-7f9ad5e0":1,"chunk-7ff17d2c":1,"chunk-9b5ecd7e":1,"chunk-cdef5632":1,"chunk-dd16c636":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"clinics-chunk":"clinics-chunk","medicine-order-details-chunk":"medicine-order-details-chunk","profiler":"profiler","recorder":"recorder"}[chunkId]||chunkId) + "." + {"chunk-00321893":"2b355ecd","chunk-10b0dbf3":"9ec157b9","chunk-0c242480":"1acd784c","chunk-7f442d4c":"31d6cfe0","chunk-a16746c4":"2012a659","clinics-chunk":"2f21f7fd","chunk-3f6c33c0":"31d6cfe0","medicine-order-details-chunk":"81ec702e","chunk-c8b00de8":"4528e16f","chunk-0720a51f":"028681b3","chunk-0e4b33d4":"6c863941","chunk-78a29d3e":"87dbe76e","chunk-16ecd102":"faa52e38","chunk-2d0cbb32":"31d6cfe0","chunk-2d0d5fb5":"31d6cfe0","chunk-2d1b9b31":"0a21269f","chunk-2d2138fa":"31d6cfe0","chunk-376798f9":"c68e2e73","chunk-40b9f627":"133c6f63","chunk-4f860653":"65a7d938","chunk-335ee7dc":"e2eb6e52","chunk-cd3633e8":"9af43a19","chunk-59f1cd2c":"4e79a2d4","chunk-5b4da50e":"e483bc7e","chunk-16712518":"4cc6e139","chunk-195141ac":"d678fdce","chunk-3b5d4ab0":"dd472d2a","chunk-c1197b9c":"1f40b77a","chunk-67536686":"7afb8d09","chunk-7cc2f306":"6adaa34c","chunk-08bf1a74":"d894809c","chunk-4dd8db56":"f0d18df6","chunk-1a5b90f4":"0c0ce8e2","chunk-1aafcde6":"275af355","chunk-296c9694":"430aeaca","chunk-7f9ad5e0":"f4f825ae","chunk-7ff17d2c":"1f0974f5","chunk-9b5ecd7e":"7b830be5","chunk-cdef5632":"f094955a","chunk-2d0a4d8d":"31d6cfe0","chunk-2d2383be":"31d6cfe0","chunk-dd16c636":"eae729fd","profiler":"31d6cfe0","recorder":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/portal/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
